import { getCookie, setCookie } from "./cookie-utils";

export default class CookieAlert {
  constructor(el) {
    this.el = el;
    this.buttonHideCookieAlert = el.querySelector(".cookies-alert-content-button");
    this.buttonHideCookieAlert.addEventListener(
      "click",
      this.hideCookieAlert.bind(this)
    );
    this.init();
  }

  init() {
    if (!getCookie("cookieAccepted")) {
      setTimeout(() => {
        this.el.classList.add("cookies-alert--visible");
      }, 1000);
    }
  }

  hideCookieAlert() {
    setCookie("cookieAccepted", "true");
    this.el.classList.remove("cookies-alert--visible");
  }
}
